import { render } from "./YoubeCatalogo.vue?vue&type=template&id=69edf7fe&scoped=true"
import script from "./YoubeCatalogo.vue?vue&type=script&lang=js"
export * from "./YoubeCatalogo.vue?vue&type=script&lang=js"

import "./YoubeCatalogo.vue?vue&type=style&index=0&id=69edf7fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69edf7fe"]])

export default __exports__